var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Input } from '@angular/core';
import * as _ from 'lodash';
import { ImportIntoUserGalleryDto } from '../../../../shared/service-proxies/service-proxies';
import { GraphicsType } from '../../shared/helpers/graphics-type-help';
import { CreateOrEditGraphComponent } from '../../element-setting/shared/graph/create-or-edit-graph.component';
import { GraphImportControlSettingComponent } from '../../element-setting/shared/control/graph-import-control-setting.component';
import { finalize } from 'rxjs/operators';
import { ConfigureComponentBase } from '../../../../shared/configure-component-base';
import { AppConsts } from '../../../../shared/AppConsts';
var GalleryCurrentComponent = /** @class */ (function (_super) {
    __extends(GalleryCurrentComponent, _super);
    function GalleryCurrentComponent(injector, abpSessionService, galleryService, modalService) {
        var _this = _super.call(this, injector) || this;
        _this.abpSessionService = abpSessionService;
        _this.galleryService = galleryService;
        _this.modalService = modalService;
        return _this;
    }
    GalleryCurrentComponent.prototype.loadGalleryConfig = function (graphName) {
        var _this = this;
        this.galleryService.getGraphs(this.configureId).subscribe(function (graphs) {
            _this.graphList = graphs.items;
            var loadByGraphName = graphName && graphName.length > 0;
            var graph;
            if (loadByGraphName) {
                graph = _.find(_this.graphList, function (g) { return g.name === graphName; });
            }
            else {
                graph = _this.graphList[0];
            }
            if (graph) {
                _this.selectGraph(graph, loadByGraphName);
            }
            else {
                _this.selectedGraph = undefined;
            }
        });
    };
    GalleryCurrentComponent.prototype.selectGraph = function (graph, forceSelect) {
        var _this = this;
        if (forceSelect === void 0) { forceSelect = false; }
        if (!forceSelect && this.selectedGraph && this.selectedGraph.id === graph.id) {
            return;
        }
        this.galleryService.getGraphStates(this.configureId, graph.id).subscribe(function (r) {
            _this.currentGraphStateList = [];
            _.each(r.items, function (state) {
                var stateGraph = {
                    id: state.id,
                    name: _this.lc('State') + state.index,
                    type: state.type
                };
                stateGraph.url = AppConsts.remoteServiceBaseUrl + state.url;
                _this.currentGraphStateList.push(stateGraph);
            });
            if (_this.currentGraphStateList.length > 0) {
                _this.currentGraphStateId = _this.currentGraphStateList[0].id;
            }
        });
        this.selectedGraph = graph;
    };
    GalleryCurrentComponent.prototype.onCreateOrEditGraph = function (id) {
        var _this = this;
        var input = { id: id, graphicsType: GraphicsType.current };
        var modalRef = this.modalService.show(CreateOrEditGraphComponent, { initialState: { parameter: input, configureId: this.configureId }, backdrop: 'static' });
        var onClosedSub = modalRef.content.onClosed.subscribe(function (result) {
            if (result) {
                _this.loadGalleryConfig(result.graphName);
            }
            onClosedSub.unsubscribe();
        });
    };
    GalleryCurrentComponent.prototype.onAddToUserGallery = function () {
        var _this = this;
        var input = new ImportIntoUserGalleryDto();
        input.configureId = this.configureId;
        input.userId = this.abpSessionService.userId;
        input.configureGraphId = this.selectedGraph.id;
        input.graphName = this.selectedGraph.name;
        abp.ui.setBusy();
        this.galleryService.importConfigureGraphIntoUserGallery(input)
            .pipe(finalize(function () { return abp.ui.clearBusy(); }))
            .subscribe(function (r) {
            if (r === 0) {
                abp.event.trigger('userGraph:Added', input.graphName);
                _this.notify.info(_this.lc('ImportSuccessfully'));
            }
            else {
                var value = {
                    graphId: _this.selectedGraph.id,
                    graphicsType: GraphicsType.current,
                    id: r,
                    list: _this.currentGraphStateList,
                    name: _this.selectedGraph.name,
                    userId: input.userId
                };
                _this.modalService.show(GraphImportControlSettingComponent, {
                    initialState: { graphState: value, configureId: _this.configureId },
                    backdrop: 'static', class: 'graphImportControlSettingModal'
                });
            }
        });
    };
    __decorate([
        Input()
    ], GalleryCurrentComponent.prototype, "configureId", void 0);
    GalleryCurrentComponent = __decorate([
        Component({
            selector: 'gallery-current',
            styles: ["﻿.design-galleryCurrent{ .galleryCurrent { border: 0; .graphSettingBox { width: 100%; } } }",
                ".gallery-wrap { ul { list-style: none; padding: 0; margin: 0; } li { cursor: pointer; } a:focus, a:hover { color: #2889d0; border: none; } a:active, a:hover { outline: 0; } .listLink { display: block; text-decoration: none; color: #303030; padding: 8px 12px 8px 10px; text-overflow: ellipsis; } .listLink:hover { text-decoration: none; background: #EEEEEE; } .listLinkSelected { display: block; text-decoration: none; padding: 8px 12px 8px 10px; background: #EEEEEE; border: 1px solid #EEEEEE; } a { color: #EEEEEE; text-decoration: none; } .graphSettingBox { height: 255px; border: 1px solid #ddd; overflow-x: auto; display: block; .font12Size { font-size: 12px; } .selectedType { background: #EEEEEE; } } .graphType { width: 140px; float: left; height: 400px; margin-right: 10px; } .graphBoxes { width: 78%; } .stateBox { height: 140px; margin-top: 5px; border: none; } .colorPick { width: 50px; } .span-inline-block { display: inline-block; width: 100%; } .backgroundBorder { padding: 5px; border: 1px solid #ddd; } .graphBtns button { height: 26px; line-height: 22px; margin-right: 10px; } }"],
            template: "<div class=\"gallery-wrap clearfix\"> <div class=\"galleryCurrent clearfix\"> <div class=\"form-group border-group\"> <div class=\"graphSettingBox graphBox\"> <graph-list [graphList]=\"graphList\" (graphSelected)=\"selectGraph($event)\" [selectedGraphId]=\"selectedGraph?.id\"></graph-list> </div> <div class=\"graphSettingBox stateBox\"> <div>{{lc(\"State\")}}:</div> <graph-state-list [stateList]=\"currentGraphStateList\" [(selectedStateId)]=\"currentGraphStateId\"></graph-state-list> </div> </div> <div class=\"graphBtns\"> <button type=\"button\" class=\"fe-btn-small fe-btn-operate\" (click)=\"onCreateOrEditGraph()\">{{lc('CreateGraph')}}</button> <button *ngIf=\"selectedGraph\" type=\"button\" class=\"fe-btn-small fe-btn-operate\" (click)=\"onCreateOrEditGraph(selectedGraph.id)\">{{lc('EditGraph')}}</button> <button type=\"button\" class=\"fe-btn-small fe-btn-operate\" (click)=\"onAddToUserGallery()\">{{lc(\"AddUserGallery\")}}</button> </div> </div> </div>"
        })
    ], GalleryCurrentComponent);
    return GalleryCurrentComponent;
}(ConfigureComponentBase));
export { GalleryCurrentComponent };
